/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

 import React from 'react'

import { Button, Col, Row } from 'reactstrap'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

import {CopyToClipboard} from 'react-copy-to-clipboard';

import prettyBytes from 'pretty-bytes';

import {AppContext} from '../AppContext';

class UserStreamingHistory extends React.Component
{
  debouncedSaveColumnWidths = null;
  columnKey = 'streamingHistory.columnWidths';
  columnWidths = {};

  componentDidMount()
  {
    this.columnWidths = this.context.appLocalStorage.getColumnWidths(this.state.columns, this.columnKey);
    document.title = this.context.websiteProfile.profileName + ': Streaming History'
    this.fetchUserStreamingHistory();
  }

  constructor(props)
  {
    super();

    let columns =
    [
      {Header: 'Object Name', id: 'objectName', accessor: 'objectName',
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Start Time', id: 'startTime', accessor: d => {return d.startTime}, 
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.startTime, true)}>{window.formatTimestamp(rowInfo.row.startTime, false)}</span></div>)},
      {Header: 'End Time', id: 'endTime', accessor: d => {return d.endTime}, 
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.endTime, true)}>{window.formatTimestamp(rowInfo.row.endTime, false)}</span></div>)},
      {Header: 'Server', id: 'serverName', accessor: 'serverName', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'User Agent', id: 'userAgent', accessor: 'userAgent', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Bytes Streamed', id: 'bytesStreamed', accessor: d => {return new Intl.NumberFormat().format(d.bytesTransmitted)} },      
      {Header: 'Client IP', id: 'clientIpAddress', accessor: 'clientIpAddress', 
        Cell: row => 
          <div>
            <CopyToClipboard text={row.value} onCopy={() => {this.context.postNotification('info', 'IP address copied to paste buffer.')}} >
              <span title={row.value}>{row.value}</span>
            </CopyToClipboard>
          </div>,
        sortMethod: (a, b, desc) =>
        {
          if (a > b)
            return 1;
          else
            return -1;
        }
      },
      {Header: 'Referer', id: 'referer', accessor: 'referer', 
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Note', id: 'note', accessor: 'note', Cell: row=> <div><span title={row.value}>{row.value}</span></div>}
    ];

    this.debouncedSaveColumnWidths = window.debounce(this.saveColumnWidths, 500);

    this.fetchUserStreamingHistory = this.fetchUserStreamingHistory.bind(this);

    this.state =
    {
      columns: columns,
      streamingHistory: [],
      spinnerIsSpinning: false
    }
  }

  async fetchUserStreamingHistory()
  {
    this.setState({spinnerIsSpinning: true});

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getUserStreamingHistory');
    this.setState({spinnerIsSpinning: false});
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading user streaming history data');
    this.setState({spinnerIsSpinning: false, streamingHistory: result.jsonData.userStreamingHistory});
  }
  
  mapBytesStreamed(logEntry)
  {
    return logEntry.bytesTransmitted;
  } 

  render()
  {
    let bytesStreamed = 0;
    if (this.state.streamingHistory.length && 1 === this.state.streamingHistory.length)
      bytesStreamed = parseInt(this.state.streamingHistory[0].bytesTransmitted, 10);
    if (this.state.streamingHistory.length && 1 !== this.state.streamingHistory.length)      
      bytesStreamed = this.state.streamingHistory.map(this.mapBytesStreamed).reduce(this.sumBytesStreamed);
    
    let prettyBytesStreamed = prettyBytes(bytesStreamed);

    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    return(
      <div>
        <Row><h2>User Streaming History</h2></Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="2"><Button color='primary' onClick={this.fetchUserStreamingHistory}>Refresh</Button></Col>
          <Col sm="2">Access Count:</Col>
          <Col sm="1">{new Intl.NumberFormat().format(this.state.streamingHistory.length)}</Col>
          <Col sm="2">Total Bytes:</Col>
          <Col sm="2">{prettyBytesStreamed}</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col>
            <ReactTable columns={this.state.columns} data={this.state.streamingHistory} minRows={1} className="-striped -highlight" 
              onResizedChange={(resizedColumns, event) => this.debouncedSaveColumnWidths(resizedColumns, event)} />
          </Col>
        </Row>
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader css={override} size={75} color={'#4A90E2'} loading={this.state.spinnerIsSpinning}/>          
        </div>
      </div>
    );
  }

  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.columnWidths, this.columnKey);
  }

  sumBytesStreamed(prev, next)
  {
    return parseInt(prev, 10) + parseInt(next, 10);
  }
}

UserStreamingHistory.contextType = AppContext;

export default UserStreamingHistory